<template>
  <div v-if="navigation">
    <h3>eDM</h3>
    <div class="h4 py-5">
      可編輯e-catalog 下方e-Catalog icon連結，未填連結者前台將導到英文版e-catalog連結
    </div>
    <div class="form-item d-flex py-5 "
         v-for="item in navigation.edms_nav"
         :key="item.key">
      <h4 class="mr-6">{{ item.key }}</h4>
      <div v-if="item.val !== '' && item.val !== null">
        <a
          :href="item.val"
          class="h4"
          style="color: #116795; text-decoration: none;"
          >{{ item.val }}</a
        >
      </div>
      <div v-else>
        (無)
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navigation: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style></style>
